module.exports = __webpack_public_path__ + "static/media/cricket.59d99305.svg";